/* import __COLOCATED_TEMPLATE__ from './address-input-field-locality-old.hbs.js'; */
var _dec, _class;
import { tagName } from '@ember-decorators/component';
import AddressInputFieldLocality from './address-input-field-locality';
let AddressInputFieldLocalityOld = (_dec = tagName(''), _dec(_class = class AddressInputFieldLocalityOld extends AddressInputFieldLocality {}) || _class);
export { AddressInputFieldLocalityOld as default };